import { styled } from '../../Styles/stitches.config'
import { StyledDefaultInput } from '../Input/styles'
import TextareaAutosize from 'react-textarea-autosize'

export const StyledTextarea = styled(TextareaAutosize, {
    display: 'block',
    ...StyledDefaultInput,
})
